
import store from '../store'
import { HTTP_HYPER_ESPACE_BACKEND } from '@/services/http-common'

export async function getRapportDiffusionGlobalES (filter) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = '/rapports-diffusions-erreurs'
      url = url + '?idAdvertisers=' + user.advertiser + '&idAdvertiser=' + user.advertiser + '&page=1' + '&size=500' + '&type=DIFFUSION'
      if (filter.portalCodeNames !== '' || filter.portalCodeNames != null) {
        url = url + '&partnerCodeName=' + filter.portalCodeNames
      }
      url = url + '&sort=endDate&direction=desc'
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getRapportDiffusionES (filter, codeName) {
  const user = store.getters.getUser
  let url = '/rapport/diffusions'
  url += '?idAdvertisers=' + user.advertiser + '&idAdvertiser=' + user.advertiser + '&partnerCodeName=' + codeName + '&TYPE=DIFFUSION&page=1&size=1&sort=endDate&direction=desc'
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return { infos: response.data }
  }).catch((e) => {
    return { infos: null }
  })
}

export async function getRapportDiffusionESById (rapportId) {
  const user = store.getters.getUser
  return HTTP_HYPER_ESPACE_BACKEND.get('/rapport/diffusion?idAdvertiser=' + user.advertiser + '&shouldExist[]=bilanAnnonces&idUniq=' + rapportId)
    .then((response) => {
      return { bilan: response.data.hits }
    }).catch((e) => {
      return { infos: null }
    })
}

export async function getRapportIntegrationGlobalES () {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      let url = '/rapport/integrations'
      url = url + '?idAdvertisers=' + user.advertiser + '&idAdvertiser=' + user.advertiser + '&page=1' + '&size=1' + '&type=INTEGRATION' + '&sort=endDate&direction=desc'
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getEnteteES () {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      const url = '/rapport/entetes/last-result?idAdvertiser=' + user.advertiser
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getEnteteDashboardES () {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      const url = '/dashboardRapportDiffusion?annonceur=' + user.advertiser
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getDataReportES (idReport) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const url = '/report?idUniq=' + idReport + '&size=1&page=1&direction=desc&sort=endDate'
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getAnnoncesRapportES (id, filter) {
  const user = store.getters.getUser
  let url = '/annonces/rapport?size=10000&idUniq=' + id
  url += '&idAdvertiser=' + user.advertiser
  if (filter.warningOnly === true) {
    url += '&level=WARN'
  }
  if (filter.integrationErrors === true) {
    url += '&level=ERROR'
  }
  return HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
    return { infos: response.data }
  })
}

export async function getMessagesRapportES (idUniq) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      const url = '/messages/rapport?idUniq=' + idUniq + '&level=ERROR,WARN&size=9999&idAdvertiser=' + user.advertiser
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

export async function getMessagesRapportParAnnonceES (idUniq, idAnnonce) {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const url = '/messages/rapport/annonce?idUniq=' + idUniq + '&level=ERROR,WARN&idAdvert=' + idAnnonce
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}

/**
 * Retourne l'en-tête d'un rapport de diffusion.
 *
 * @returns {object}
 */
export async function getEnteteRapportDiffusionGlobal () {
  return new Promise(resolve => {
    window.setTimeout(function () {
      const user = store.getters.getUser
      const url = '/annonceur-rapport-global?id=' + user.advertiser
      HTTP_HYPER_ESPACE_BACKEND.get(url).then((response) => {
        return resolve({
          infos: response.data
        })
      })
    }, Math.random() * 1000 + 250)
  })
}
